/**
 * Authentication and authorisation functions.
 */
import store from "../store";

/**
 * Check that the currently logged in user is a superadmin.
 * Note that in most cases, superadmins act as a normal admin for the company they are in. The main exceptions are
 * for company and user management.
 */
const authUserIsSuperadmin = () => {
  return store.state.user.role === "superadmin";
};

/**
 * Check that the currently logged in user is a has admin permissions.
 */
const authUserIsAdmin = () => {
  return ["admin", "superadmin"].includes(store.state.user.role);
};

/**
 * Check that the currently logged in user has curator permissions.
 */
const authUserIsCurator = () => {
  return ["curator", "admin", "superadmin"].includes(store.state.user.role);
};

/**
 * Check that the user is authorised to access the specified route.
 * Routes may have the following role requirements:
 *  none - user is logged in but has no special role
 *  curator - user is logged in and a curator
 *  admin - user is logged in and a site admin
 *  superadmin - user is logged in and a superadmin
 *  loggedout - user must be logged out
 * If role is not set (or set false) on the route then anyone is allowed to access it.
 * @param {String} requiredRole
 */
const authUserAuthorised = (requiredRole) => {
  // First handle pages which have no user restrictions.
  if (requiredRole === "all") {
    return true;
  }

  // Now handle pages which do have restrictions ...
  if (store.state.user.logged_in) {
    // The user is logged in ...
    switch (requiredRole) {
      case "none":
        return true;
      case "curator":
        return ["curator", "admin", "superadmin"].includes(store.state.user.role);
      case "admin":
        return ["admin", "superadmin"].includes(store.state.user.role);
      case "superadmin":
        // IMPORTANT - superadmins act as admins for the company that they are in (typically the public company).
        // Additionally they have special superadmin permissions in certain areas, particularly with regards to
        // managing users and companies.
        return store.state.user.role === "superadmin";
    }
  } else {
    // The user is logged out ...
    if (requiredRole === "loggedout") {
      return true;
    }
  }

  // Default to no access.
  return false;
};

/**
 * Check that the user is currently on an allowed site.
 * @param {Array} requiredDomains
 */
// const authDomainAuthorised = requiredDomains => {
//   if (!requiredDomains) {
//     return true;
//   }

//   const hostname = window.location.hostname;

//   // Allow development site
//   if (process.env.NODE_ENV === "development" && hostname === "firmacademy") {
//     return true;
//   }

//   // Apply the actual domain restrictions
//   let allowed = false;
//   requiredDomains.forEach(domain => {
//     if (hostname === domain || hostname === `www.${domain}` || hostname === `dev.${domain}`) {
//       allowed = true;
//     }
//   });
//   return allowed;
// };

export { authUserAuthorised, authUserIsSuperadmin, authUserIsAdmin, authUserIsCurator }; // authDomainAuthorised
